import { useSyncExternalStore } from 'react';
import { ECOMM_EVENTS } from '../types/EcomSDK';

function getSnapshot(): number {
    return window._ecomm?.state?.cart?.items?.count ?? 0;
}

function getServerSnapshot(): number {
    return 0;
}

function subscribe(callback: () => void): () => void {
    // At subscribe time window._ecomm is usually still the lightweight preload
    // stub ({ ready, markAsReady }) injected by the snipcart loader — it has no
    // `events`/`state`. The real SDK replaces window._ecomm once it has loaded,
    // reusing the same `ready` promise. So we only capture `ready` here and
    // re-read window._ecomm after it resolves (matching every other consumer).
    const ready = window._ecomm?.ready;
    if (!ready) return () => {};

    const unsubscribers: Array<() => void> = [];
    let isActive = true;

    // Subscribe after sdk is fully ready and emit once to refresh initial state.
    ready
        .then(() => {
            if (!isActive) return;
            const sdk = window._ecomm;
            if (sdk?.events) {
                ECOMM_EVENTS.forEach((event) => {
                    if (!isActive) return;
                    unsubscribers.push(sdk.events.on(event, callback));
                });
            }
            // Refresh the snapshot once now that the SDK is ready — even if we
            // couldn't subscribe to events, state.cart may already be populated.
            callback();
        })
        .catch(() => {});

    return () => {
        isActive = false;
        // Unsubscribe from events
        unsubscribers.forEach((unsubscriber) => unsubscriber());
    };
}

export function useCartItemsCount(): number {
    const itemsCount = useSyncExternalStore(
        subscribe,
        getSnapshot,
        getServerSnapshot
    );
    return itemsCount;
}
